import { createAction } from 'redux-actions';

export const setProductResults = createAction('SET_PRODUCT_RESULTS');
export const setListsResults = createAction('SET_LISTS_RESULTS');
